import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "../../public/locales/en/translation.json";
import translationES from "../../public/locales/es/translation.json";

const resources = {
    en: {
        translation: translationEN,
    },
    es: {
        translation: translationES,
    },
};

export const i18nConfig = {
    resources,
    fallbackLng: "en",
    returnEmptyString: false,
    interpolation: {
        escapeValue: false,
        prefix: "%(",
        suffix: ")s",
    },
    nsSeparator: "|||",
};

export default (language: string) =>
    i18n.use(initReactI18next).init({
        ...i18nConfig,
        lng: language,
    });
